import React, { useEffect, useState } from "react";
import PageHeader from "../../components/general/pageHeader/pageHeader";
import DocumentsWithSearchComponent from "../../components/documentsWithSearch/index";
import "./style.css";
import { FormattedMessage } from "react-intl";
import HeaderDocumentsImg from "../../assets/img/Head-Documenti.svg";
import { usePermissions } from "../../customHooks";
import Page from "../../components/general/page";
import { FEATURE_TOGGLE_BUSINESS_INFORMATION } from "../../config";
import BisChildApp from "../../components/general/bisChildApp";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";

const DocumentsWithSearch = ({pageRef}) => {
  const [isOwner, setIsOwner] = useState(false);
  const [buyDocument, setBuyDocument] = useState(false);
  const company = useSelector(state => state.company);
  const user = useSelector(state => state.user);
  const currentPermissions = useSelector(state => state.currentPermissions);
  const usersList = useSelector(state => state.usersList);
  const main = useSelector(state => state.main);
  const accountantSelected = main.accountantSelected;
  const accountantIdSelected = main.accountantIdSelected;
  const companySelected = main.companySelected;
  const clientIdSelected = main.clientIdSelected;
  const myType = main.myType;
  const prevPath = main.prevPath;

  const intl = useIntl();

  const { isPermissionWebUpload, isPermissionStudioUpload } = usePermissions(
    currentPermissions,
    null,
    isOwner
  );

  useEffect(() => {
    if (window.aptrinsic) {
      if (myType === "STUDIO") {
        window.aptrinsic("track", "digital-box:DOCS-STUDIO");
      } else {
        window.aptrinsic("track", "digital-box:DOCS-COMPANY");
      }
    }
    const roles = user.roles;
    const isOwnerResources = roles.filter(resource =>
      resource.actionKey === "OWNER" &&
      (resource.appId === "DBX" || resource.appId === null));
    const currentStudio = isOwnerResources.filter(res => res.resourceId === accountantIdSelected);

    if (currentStudio.length > 0) {
      setIsOwner(true);  
    }
  }, []);

  useEffect(() => {
    if (!usersList || !user) return;
   
    const roles = user.roles;
    const isOwnerResources = roles.filter(resource =>
      resource.actionKey === "OWNER" &&
          (resource.appId === "DBX" || resource.appId === null));
    const currentStudio = isOwnerResources.filter(res => res.resourceId === accountantIdSelected);

    if (currentStudio.length > 0) {
      setIsOwner(true);      
    }
    
  }, [usersList, user]);
  
  if (!companySelected) return null;
  let ragioneSociale =
  company && company.companies
    ? company.companies.find(el => {
      return el.codiceFiscale === companySelected;
    })?.ragioneSociale
    : null;

  const title = (
    <>
      <FormattedMessage id="documents.headerTitle.firstPart" />{" "}
      <b>
        <FormattedMessage id="documents.headerTitle.boldPart" />{" "}
      </b>
      <FormattedMessage id="documents.headerTitle.secondPart" />
    </>
  );

  const subtitle = (
    <>
      <b>
        <FormattedMessage id="documents.headerSubtitle.boldPart" />
      </b>{" "}
      <FormattedMessage id="documents.headerSubtitle.secondPart" />
      {FEATURE_TOGGLE_BUSINESS_INFORMATION === "true" && <><br /><br />
        <FormattedMessage id="documents.headerSubtitle.bisPart" />
        {" "}
        <span className="dbx-documents-header-buyDocument" onClick={() => setBuyDocument(true)} href="#">
          <FormattedMessage id="documents.headerSubtitle.bisLinkPart" />
        </span>
      </>}
    </>
  );

  return (
    <Page
      pageRef={pageRef}
      className="contentStructure transparent"
      subClassName="pageCss"        
      title={<FormattedMessage id="documents.title" />}
      subtitle={ragioneSociale + " / " + intl.formatMessage({ id: "generic.fiscalCodeAbbreviation" }) + " " + companySelected}
      noHeaderContent={buyDocument}
    >
      {buyDocument && <BisChildApp onClose={() => setBuyDocument(false)} />}
      {!buyDocument && <><div className="cardDocumentCss">
        <PageHeader
          image={`${HeaderDocumentsImg}`}
          title={title}
          subtitle={subtitle}
          isDocumentsPage={true}
          isPermissionWebUpload={isPermissionWebUpload}
          isPermissionStudioUpload={isPermissionStudioUpload}
          myType={myType}            
        />
      </div>
      <div className="headerSeparator"></div>
      <div className="cardDocumentCss">
        <DocumentsWithSearchComponent
          accountantSelected={accountantSelected}
          accountantIdSelected={accountantIdSelected}
          clientIdSelected={clientIdSelected}
          companySelected={companySelected}            
          myType={myType}
          prevPath={prevPath}
        />
      </div></>}
    </Page>
  );
};

export default DocumentsWithSearch;
